import React, { useState } from "react";
import { ROOM_TEMPLATES } from "../../constants";

export default function RoomPopup({ faceId, st, screenPt, onAssign, onClose }) {
  const [rt, setRt] = useState((st.rooms || {})[faceId]?.type || "ROOM");
  const [rn, setRn] = useState((st.rooms || {})[faceId]?.name || "");
  if (!faceId || !screenPt) return null;

  return (
    <div style={{
      position: "absolute", left: screenPt.x, top: screenPt.y,
      background: "#09090f", border: "1px solid #1e3d66",
      borderRadius: 8, padding: "12px 14px", zIndex: 50, width: 205, boxShadow: "0 8px 32px #000c",
    }}>
      <div style={{ fontSize: 8, color: "#3b82f6", letterSpacing: 2, marginBottom: 8, fontWeight: 800 }}>
        ASSIGN ROOM TYPE
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 3, marginBottom: 8 }}>
        {Object.entries(ROOM_TEMPLATES).map(([k, t]) => (
          <button
            key={k}
            onClick={() => setRt(k)}
            style={{
              padding: "4px", borderRadius: 3, fontSize: 8, cursor: "pointer", textAlign: "left",
              background: rt === k ? "#1e3d6688" : "#0c1320",
              border: rt === k ? "1px solid #3b82f6" : "1px solid #131924",
              color: rt === k ? "#60a5fa" : "#4a5e70",
            }}
          >
            {t.icon} {t.label}
          </button>
        ))}
      </div>

      <input
        value={rn}
        onChange={e => setRn(e.target.value)}
        placeholder="Name (optional)"
        style={{
          width: "100%", padding: "4px 6px", background: "#0c1320",
          border: "1px solid #131924", color: "#8496a8", borderRadius: 3,
          fontSize: 9, marginBottom: 8, fontFamily: "inherit", boxSizing: "border-box",
        }}
      />

      <div style={{ display: "flex", gap: 5 }}>
        <button onClick={() => onAssign(rt, rn)} style={{ flex: 1, padding: "5px", background: "#0c2318", border: "1px solid #4ade8040", color: "#4ade80", borderRadius: 3, cursor: "pointer", fontSize: 9 }}>
          ✓ Apply
        </button>
        <button onClick={onClose} style={{ padding: "5px 8px", background: "transparent", border: "1px solid #131924", color: "#4a5e70", borderRadius: 3, cursor: "pointer", fontSize: 9 }}>
          ✕
        </button>
      </div>
    </div>
  );
}
